import { ComunicationModel } from '../../../api/Argentia/model/comunication/comunications'
import { DataTableActionConfiguration, ActionIcons } from '../../../model'
import { ExternalModel } from '../../../pages/comunicationCenter/tabs/externals/comunicationExternals.model'

export const filterApplicableActionsConfiguration = (
  item: ComunicationModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        applicableActionsConfiguration.push(configuration)

        break
      }
      case ActionIcons.LOADING: {
        applicableActionsConfiguration.push(configuration)

        break
      }
    }
  })

  return applicableActionsConfiguration
}
